import * as React from 'react';
import {Dialog} from 'material-ui';
import {IHistory} from '../../interfaces';
import {Loader} from '../reusableComponents/Loader/Loader';
import {CustomFlatButton} from '../reusableComponents/CutomFlatButton';
import {OrgModel} from '../../model/OrgModel';
import {deactivateOrganization} from '../../services/organizationService';

export interface IDeleteOrgDialogProps {
    instance: OrgModel;
    onClose: Function;
    open: boolean;
    orgStatus?: boolean;
    history: IHistory;
}

export interface IDeleteOrgDialogState {
    open: boolean;
    isLoading: boolean;
}

export class DeleteOrganizationDialog extends React.PureComponent<IDeleteOrgDialogProps, IDeleteOrgDialogState> {
    constructor(props: IDeleteOrgDialogProps) {
        super(props);
        this.state = {open: false, isLoading: false};
    }

    public componentWillReceiveProps(nextProps: IDeleteOrgDialogProps) {
        this.setState({
            open: nextProps.open
        });
    }

    public handleClose = () => {
        this.setState({
            open: false
        });
        this.props.onClose();
    }

    public handleOrgDelete = async () => {
        const {id} = this.props.instance.props;
        try {
            this.setState({isLoading: true});
            await deactivateOrganization(this.props.instance, this.props.orgStatus, this.props.history);
            this.setState({open: false, isLoading: false});
        } catch (error) {
            this.setState({open: false, isLoading: false});
            throw error;
        }
    }

    public render() {
        if (!this.props.instance) {
            return '';
        }
        return <Dialog
            title={`Do you really want to ${this.props.orgStatus ? 'activate' : 'deactivate'} ${this.props.instance.props.OrganizationName}'?`}
            modal={false}
            className="url-modal"
            open={this.state.open}
            actions={
                [
                    <CustomFlatButton
                        label="No"
                        color={'black'}
                        primary={true}
                        onClick={this.handleClose}
                    />,
                    <CustomFlatButton
                        label="Yes"
                        color={'black'}
                        primary={true}
                        onClick={this.handleOrgDelete}
                    />
                ]
            }
            onRequestClose={this.handleClose}
        >
            {this.state.isLoading ? <Loader type="submission"/> : ''}
            Click yes to proceed or No to cancel
        </Dialog>;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Organization/DeleteOrganizationDialog.tsx